// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yc9q","comment":"styles_comment__33KQW"};